import React, { useState } from 'react';
import '../css/Modal.css'; // Your custom styles

function ConfirmModalLogout({ isOpen, onClose, onConfirm }) {
  
  if (!isOpen) return null;
  return (
    <div className="modal-overlay">
      <div className="modal-content">
          <div style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              flexDirection: 'column',
              marginTop: 20
          }}>
                            <span
                style={{
                        minWidth: '200px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontFamily: 'nunito sans',
                        fontWeight: 700,
                        marginBottom: 20
                }}>¿Seguro que desea cerrar sesión?</span>
              <div style={{
                  display: 'flex',
                  flexDirection: 'row'
              }}>
              <button className="cancel" onClick={onClose}>Cancelar</button>
              <button className="success" onClick={onConfirm}>Aceptar</button>
              </div>

          </div>

      </div>
    </div>
  );
}

export default ConfirmModalLogout;